import { genreOptions, regionOptions, yearOptions } from "@/mocks/site";

export interface FilterSelection {
  genres: string[];
  regions: string[];
  years: string[];
}

interface FilterSidebarProps {
  selection: FilterSelection;
  onToggle: (group: keyof FilterSelection, value: string) => void;
  onClear: () => void;
}

function FilterGroup({
  title,
  options,
  selected,
  group,
  onToggle,
}: {
  title: string;
  options: { label: string; value: string }[];
  selected: string[];
  group: keyof FilterSelection;
  onToggle: (group: keyof FilterSelection, value: string) => void;
}) {
  return (
    <div className="flex flex-col gap-3 border-b border-background-200 pb-5 last:border-b-0 last:pb-0">
      <h3 className="text-sm font-semibold text-foreground-950">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = selected.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onToggle(group, opt.value)}
              className={`cursor-pointer whitespace-nowrap rounded-md border px-2.5 py-1 text-xs transition-colors ${
                active
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterSidebar({ selection, onToggle, onClear }: FilterSidebarProps) {
  const total = selection.genres.length + selection.regions.length + selection.years.length;

  return (
    <div className="flex flex-col gap-5 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-1.5 text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选条件
        </h2>
        {total > 0 ? (
          <button
            type="button"
            onClick={onClear}
            className="cursor-pointer whitespace-nowrap text-xs text-primary-600 hover:text-primary-700"
          >
            清除全部
          </button>
        ) : null}
      </div>
      <FilterGroup
        title="影视类型"
        options={genreOptions}
        selected={selection.genres}
        group="genres"
        onToggle={onToggle}
      />
      <FilterGroup
        title="地区"
        options={regionOptions}
        selected={selection.regions}
        group="regions"
        onToggle={onToggle}
      />
      <FilterGroup
        title="上映年份"
        options={yearOptions}
        selected={selection.years}
        group="years"
        onToggle={onToggle}
      />
    </div>
  );
}